import { render, staticRenderFns } from "./config-UK.vue?vue&type=template&id=62263fec"
import script from "./config-UK.vue?vue&type=script&lang=js"
export * from "./config-UK.vue?vue&type=script&lang=js"
import style0 from "./config-UK.vue?vue&type=style&index=0&id=62263fec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports